import SEO from "../components/SEO";

export default function Privacy() {
  return (
    <div className="parchment min-h-screen pt-24 pb-24 px-6" data-testid="privacy-page">
      <SEO
        title="Privacy Policy"
        description="How The Salty Moo™ keeps your email and information safe."
        path="/privacy"
      />
      <div className="max-w-2xl mx-auto parchment-deep page-shadow border border-[#E7DFD5] rounded-md px-10 py-12">
        <p className="text-xs uppercase tracking-[0.4em] text-[#D62839] mb-3">
          The fine print, gentled
        </p>
        <h1 className="font-display text-5xl text-[#4B3A2F] mb-2">Privacy</h1>
        <div className="gold-rule w-20 mb-8" />

        <div className="space-y-5 font-body text-[#2C2724]/90 text-lg leading-relaxed">
          <p>
            The Salty Moo™ collects only what you willingly share — an email
            address when you subscribe on the Front Porch — so we can send you
            gentle pasture stories, news of new books, and the occasional
            Saltie Wink™.
          </p>
          <p>
            We do not sell, rent, or trade your email. Ever. If you would like
            to leave, just reply to any email and we&rsquo;ll take you back off
            the list, no questions asked.
          </p>
          <p>
            Emails are delivered by our transactional email provider (Resend).
            Their handling of your address is governed by their own privacy
            terms.
          </p>
          <p>
            The site uses standard analytics to understand which chapters
            readers enjoy most, and no personally identifying information is
            shared with third parties beyond what is required to deliver the
            site itself.
          </p>
          <p className="font-script text-2xl text-[#4B3A2F] pt-4">
            questions? just holler.
          </p>
          <p>
            Reach out any time — hello@thesaltymoo.com — and a real person on
            the pasture will write you back.
          </p>
        </div>
      </div>
    </div>
  );
}
